{
  "id": "campaign-126",
  "name": "Center Ground",
  "seed": "campaign:126",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r....QQQQ....r",
    "..:..,,,...:..",
    "..:.....x..:..",
    "..::::::::::..",
    ".a..........a.",
    "...a......a...",
    "..q..a..a..q..",
    ".a.a...x..a.a,",
    "::::::::::::::",
    ".....a..a..#.,",
    "..q........q..",
    ".a.a.a..a,a.a.",
    "..::::::::::..",
    "..:......,~:~.",
    "..:........:..",
    ".....QQQQ....S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 5,
      "y": 7
    },
    {
      "kind": "rabbit",
      "x": 12,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 11
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 6
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 13,
      "y": 7
    },
    {
      "kind": "gas",
      "x": 11,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 7
    }
  ],
  "balls": {
    "first": 18,
    "every": 15
  },
  "generatorVersion": 3,
  "level": 126,
  "biome": "stadium",
  "par": {
    "reel": 7706,
    "push": 6458,
    "selfPropelled": 6009,
    "tractor": 5005,
    "zeroTurn": 4311,
    "fairway": 2588
  },
  "goldTime": {
    "reel": 7316,
    "push": 6198,
    "selfPropelled": 5850,
    "tractor": 4905,
    "zeroTurn": 4245,
    "fairway": 2087
  },
  "routeTries": {
    "par": {
      "reel": 2,
      "push": 13,
      "selfPropelled": 12,
      "tractor": 14,
      "zeroTurn": 2,
      "fairway": 22
    },
    "gold": {
      "reel": 29,
      "push": 33,
      "selfPropelled": 30,
      "tractor": 45,
      "zeroTurn": 40,
      "fairway": 47
    }
  }
}
